import { render, staticRenderFns } from "./RichTextInputDialog.vue?vue&type=template&id=6c8eff66&"
import script from "./RichTextInputDialog.vue?vue&type=script&lang=ts&"
export * from "./RichTextInputDialog.vue?vue&type=script&lang=ts&"
import style0 from "./RichTextInputDialog.vue?vue&type=style&index=0&id=6c8eff66&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports